import { useState, useEffect } from "react";
import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectItem,
  MultiSelectTrigger
} from "../ui/multiselect";
import { Input } from "../ui/input";
import { Search } from "lucide-react";

export const FilterMultiSelect = ({
  label,
  keyName,
  value,
  onValueChange,
  options,
  openDropdownKey,
  setOpenDropdownKey
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(
    options.filter(opt => opt !== null && opt !== undefined)
  );

  // Debounce filter logic
  useEffect(() => {
    const handler = setTimeout(() => {
      const query = searchQuery.trim().toLowerCase();
      setFilteredOptions(
        options.filter(
          option => option && option.toString().toLowerCase().includes(query)
        )
      );
    }, 300);

    return () => clearTimeout(handler);
  }, [searchQuery, options]);

  return (
    <div key={keyName} className="space-y-2">
      <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
        {label}
      </label>
      <MultiSelect
        value={value}
        onValueChange={onValueChange}
        dropdownKey={keyName}
        openDropdownKey={openDropdownKey}
        setOpenDropdownKey={setOpenDropdownKey}
      >
        <MultiSelectTrigger className="w-full h-9 px-3 rounded-md border border-input bg-white text-sm ring-offset-background">
          {value?.length > 0 ? value.join(", ") : `Select ${label}`}
        </MultiSelectTrigger>

        <MultiSelectContent>
          {/* Search input */}
          <div className="px-3 py-2 border-b sticky top-0 bg-white rounded-t-md">
            <div className="relative">
              <Search className="h-4 w-4 text-gray-400 absolute left-3 top-[10px]" />
              <Input
                type="text"
                placeholder={`Search ${label}`}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                onClick={e => e.stopPropagation()}
                className="h-8 pl-8 text-sm bg-gray-50 border-0 focus:ring-1 focus:ring-gray-200"
              />
            </div>
          </div>

          {/* Options list */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, idx) => (
              <MultiSelectItem key={`${option}-${idx}`} value={option}>
                {option}
              </MultiSelectItem>
            ))
          ) : (
            <div className="px-2 py-4 text-sm text-gray-500 text-center">
              No matching results
            </div>
          )}
        </MultiSelectContent>
      </MultiSelect>
    </div>
  );
};
